var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    enableBackground: "new 0 0 12 9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 12,
    height: 9,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAMAAAAxZj1mAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAOVBMVEX////8/f39/f7ByNu/ xtqnsMzAxtqvt9Gvt9Dw8fbx8/ewuNHy8/fCyNzx8vfn6fGxudKyutLk5/AXzNcNAAAAAWJLR0QA iAUdSAAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+UHDgcHIkfMShQAAABBSURBVAjXRUxJ AoAgEIIMR0tt+f9jy6mMEzvQQWJgCjN/Ln2KUWaKfP2Ul9Uz50BxVWWtF5qpYtvzMy3HeffGKS4+ uAFmihNsNgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wNy0xNFQwNzowNzozMyswMDowMCLVDuIA AAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDctMTRUMDc6MDc6MzMrMDA6MDBTiLZeAAAAAElFTkSu QmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingUpArrow);
export default __webpack_public_path__ + "static/media/sorting_up_arrow.bb4288d2.svg";
export { ForwardRef as ReactComponent };